export class Position {
    id: number;
    lat: number;
    lng: number;
    idTracker: number;
    dateTime: Date;
    velocity: number;
    start: boolean;
    isVisible: boolean = true;
    address: string;
    isSame: boolean;
    sameCount: number;
    firstSameDateTime: Date;


    //True when is on the Panic's range
    isPanic: boolean = false;
    //Used to verify when the point is on route (desvio de rota)
    isProcessed:boolean = false

    constructor (id:number, idTracker:number, lat:number, lng:number, dateTime:Date, velocity:number, start:boolean, address:string, isSame:boolean, sameCount:number, firstSameDateTime:Date) {
        this.id = id;
        this.lat = lat;
        this.lng = lng;
        this.idTracker = idTracker;
        this.dateTime = dateTime;
        this.velocity = velocity;
        this.start = start;
        this.address = address;
        this.isSame = isSame;
        this.sameCount = sameCount;
        this.firstSameDateTime = firstSameDateTime;
    }
    
/*
    public getCustomTime(dateTime:Date) {
        if (dateTime) {
            //TODO: tratar conforme vem o rawdata
            var fullYear:number = null;//dateTime.getUTCFullYear();
            var month:number = dateTime.getUTCMonth() + 1;
            var day:number = dateTime.getUTCDate() - 1;

            var customDate:string = 'teasdf';
            if (month <= 9) {
                customDate = fullYear + '-0' + month + '-' + day; 
            } else {
                customDate = fullYear + '-' + month + '-' + day;
            }
            return customDate;
        }
    }
*/
    public getCustomTime() 
    {
            var date:Date = new Date(this.dateTime);
            var hour:number = date.getHours();
            var minutes:string = '0';
            if ( date.getMinutes() < 10 ) {
                minutes += date.getMinutes();
            }
            else {
                minutes = date.getMinutes().toString();
            }
            return hour + ':' + minutes;
        
    }

    public getCustomDate () 
    {
        var date:Date = new Date(this.dateTime);
        var fullYear:number = date.getFullYear();
        var month:number = date.getUTCMonth() + 1;
        var day:number = date.getDate();

        return day + '/' + month + '/' + fullYear;
    }

    private getFirstSameCustomTime() 
    {
            var date:Date = new Date(this.firstSameDateTime);
            var hour:number = date.getHours();
            var minutes:string = '0';
            if ( date.getMinutes() < 10 ) {
                minutes += date.getMinutes();
            }
            else {
                minutes = date.getMinutes().toString();
            }
            return hour + ':' + minutes;
        
    }

    private getFirstSameCustomDate () 
    {
        var date:Date = new Date(this.firstSameDateTime);
        var fullYear:number = date.getFullYear();
        var month:number = date.getUTCMonth() + 1;
        var day:number = date.getDate();

        return day + '/' + month + '/' + fullYear;
    }


    // Time in minutes - Difference from firstSameDateTime x dateTime
    private timeDiff() {
        // Usar como argumento as datas recuperadas do servidor
        var inicio:Date = new Date(this.firstSameDateTime);
        var fim:Date = new Date(this.dateTime);

        // A diferença "d" de datas bruta retorna como milissegundos (inteiro)
        var d:Date = new Date( fim.getTime() - inicio.getTime() );

        // Mostrando:
        var tempo = '';

        (d.getUTCHours() > 0) ? tempo += ('0' + d.getUTCHours()).slice(-2) + 'h ' : '';
       
        if ((d.getUTCSeconds() >= 30)) {
            (d.getUTCMinutes()+1 > 0) ? tempo += ('0' + (d.getUTCMinutes() + 1)).slice(-2) + 'm ' : '';
        } else {
            (d.getUTCMinutes() > 0) ? tempo += ('0' + d.getUTCMinutes()).slice(-2) + 'm ' : '';
        }
        
        if (tempo == '') {
            tempo = '0m';
        }
        //console.log( tempo );
        return tempo;
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader?keepUrl=true!./app/shared/entities/position.ts